import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import {environment} from '../../environments/environment';
import {Observable, throwError} from 'rxjs';
import {catchError} from 'rxjs/operators';

@Injectable()
export class GetAllocationMarketDataService {

    constructor(private httpClient: HttpClient) {
    }

    private getMarketListUrl = environment.baseUrl + environment.dealerServiceUrl + environment.getMarketListUrl;
    private getdealerViewListUrl = environment.baseUrl + environment.dealerServiceUrl  + environment.getdealerViewListUrl;
    private getMarketLanguageMappingListUrl = environment.baseUrl + environment.dealerServiceUrl  + environment.getMarketLanguageMappingListUrl;
    private getMulitpleMarketUsersListUrl = environment.baseUrl + environment.dealerServiceUrl  + environment.getMulitpleMarketUsersListUrl;
    private getSwitzerlandi18nUrl = environment.baseUrl + environment.dealerServiceUrl  + environment.getSwitzerlandi18nUrl;
    private getZoneManagerMailidListUrl = environment.baseUrl + environment.dealerServiceUrl  + environment.getZoneManagerMailidListUrl;
    private cdsId = sessionStorage.getItem('cdsId');

    static handleError(error: any) {
        return throwError(() => error);
    }


    private getHttpHeadersApigee() {
            return new HttpHeaders({
			Authorization: 'Bearer ' + sessionStorage.getItem('authToken'),
			'Access-Control-Allow-Origin': '*'
		});
        }

    public getMarketList() {
        return this.httpClient.get<any[]>(this.getMarketListUrl, {
            headers: this.getHttpHeadersApigee()
        }).pipe(catchError(GetAllocationMarketDataService.handleError));
    }

    public getDealerViewList() {
        return this.httpClient.get<any[]>(this.getdealerViewListUrl, {
            headers: this.getHttpHeadersApigee()
        }).pipe(catchError(GetAllocationMarketDataService.handleError));
    }

    public getMarketLanguageMappingList() {
        return this.httpClient.get<any[]>(this.getMarketLanguageMappingListUrl, {
            headers: this.getHttpHeadersApigee()
        }).pipe(catchError(GetAllocationMarketDataService.handleError));
    }

    public getMulitpleMarketUsersList() {
        return this.httpClient.get<any[]>(this.getMulitpleMarketUsersListUrl, {
            headers: this.getHttpHeadersApigee()
        }).pipe(catchError(GetAllocationMarketDataService.handleError));
    }

    public getSwitzerlandi18nList() {
        return this.httpClient.get<any[]>(this.getSwitzerlandi18nUrl, {
            headers: this.getHttpHeadersApigee()
        }).pipe(catchError(GetAllocationMarketDataService.handleError));
    }

    public getZoneManagerMailidList(environment: boolean) {
        const params = new HttpParams().set('environment', environment);
        return this.httpClient.get<any[]>(this.getZoneManagerMailidListUrl, {
            headers: this.getHttpHeadersApigee(), params
        }).pipe(catchError(GetAllocationMarketDataService.handleError));
    }


}